import { render, staticRenderFns } from "./CurrentVsRecommended.vue?vue&type=template&id=162e625f&lang=pug"
import script from "./CurrentVsRecommended.vue?vue&type=script&lang=js"
export * from "./CurrentVsRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports